import { AssistResponse } from '../types'

const languages = ['en', 'ar']

const failureModalTranslates = {
  smth_went_wrong: {
    [languages[0]]: 'Something went wrong',
    [languages[1]]: 'حدث خطأ ما',
  },
}

const failureModalData = (lang): AssistResponse => {
  if (!languages.includes(lang)) {
    lang = languages[0]
  }
  return {
    result: true,
    render_type: 'popup_icon',
    content: {
      icon: 'warring',
      title: failureModalTranslates.smth_went_wrong[lang],
      subtitle: null,
      reasons: null,
      buttons: [],
      additional: null,
    },
  }
}

export default failureModalData
